import request from "@utils/request";

/*
 * 商品分类
 * */
export function getCategory(params) {
  return request({
    url: "Products/getProductClass",
    params
  });
}

/*
 * 商品详情
 * */
export function getProductDetail(params) {
  return request({
    url: "Products/detail",
    params
  });
}

/*
 * 商品分销二维码
 * */
export function getProductCode(data) {
  return request({
    url: "Products/getBase64code",
    method: "post",
    data
  });
}

/**
 * 获取个人二维码
 */
export function getQrBase64code() {
  return request({
    url: "Index/getQrBase64code"
  });
}

/*
 * 商品列表
 * */
export function getProducts(data) {
  return request({
    url: "Products/getList",
    method: "post",
    data
  });
}

/*
 * 购物车数量
 * */
export function getCartNum() {
  return request.get("/cart/count");
}

/*
 * 添加收藏
 * */
export function toCollect(id, category) {
  return request.get("/collect/add/" + id + "/" + category);
}

/*
 * 为你推荐
 * */
export function getHostProducts(page, limit) {
  console.log(page, limit);
  return request({
    url: "Products/hot"
  });
}

/*
 * 精品、热门、首发列表
 * */
export function getGroomList(type) {
  return request.get("/groom/list/" + type, {}, { login: false });
}

/*
 * 购物车 添加
 * */
export function postCartAdd(data) {
  return request({
    url: "Card/add",
    method: "post",
    data
  });
}

/*
 * 购物车列表
 * */
export function getCartList(params) {
  return request({
    url: "Card/getList",
    params
  });
}

/*
 * 购物车 删除
 * */
export function postCartDel(data) {
  return request({
    url: "Card/del",
    method: "post",
    data
  });
}

/*
 * 购物车 获取数量
 * */
export function getCartCount(params) {
  return request({
    url: "Card/count",
    params
  });
}

/*
 * 购物车 修改商品数量
 * */
export function changeCartNum(product_id, cart_num) {
  return request({
    url: "Card/change",
    params: { product_id, cart_num }
  });
}

/**
 * 搜索推荐关键字
 */
export function getSearchKeyword() {
  return request.get("/search/keyword", {}, { login: false });
}

/**
 * 产品评论列表
 */
export function getReplyList(id, q) {
  return request.get("/reply/list/" + id, q, { login: false });
}

/**
 * 产品评价数量和好评度
 */
export function getReplyConfig(id) {
  return request.get("/reply/config/" + id, {}, { login: false });
}

/**
 * 评价页面获取单个产品详情
 */
export function postOrderProduct(unique) {
  return request.post("/order/product", { unique }, { login: false });
}

/**
 * 提交评价页面；
 */
export function postOrderComment(data) {
  return request.post("/order/comment", data, { login: false });
}
